var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrationLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 313,
    height: 235.974,
    viewBox: "0 0 313 235.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.283,
    x2: 0.5,
    y2: 1.235,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3787c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9d690"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_49_1",
    "data-name": "Component 49 \\u2013 1",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4773",
    "data-name": "Group 4773",
    transform: "translate(-505.985 -240.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4770",
    "data-name": "Group 4770",
    transform: "translate(538.069 284.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4766",
    "data-name": "Group 4766",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2957",
    "data-name": "Rectangle 2957",
    transform: "translate(22.372)",
    fill: "#dbebc5",
    stroke: "#f7f7f7",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257.544,
    height: 190.722,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 253.544,
    height: 186.722,
    rx: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M32.707,126.3a35.041,35.041,0,0,1-12.553-2.288,32.611,32.611,0,0,1-10.336-6.321A29.486,29.486,0,0,1,0,96.223a29.136,29.136,0,0,1,1.583-9.94,32.788,32.788,0,0,1,4.668-8.874A34.473,34.473,0,0,1,22.134,65.462L20.954.339,41.114,0l.236,7.359,20.161-.34.082,5.221H54.675v5.021h7l.07,4.393H54.675v5.021h7.147l.07,4.432-20.162.338L42.3,65.124a34.845,34.845,0,0,1,16.3,11.091,31.518,31.518,0,0,1,4.985,8.51,28.448,28.448,0,0,1,1.941,9.791,29.8,29.8,0,0,1-2.364,12.239,30.968,30.968,0,0,1-6.858,10.04A32.739,32.739,0,0,1,46,123.639a33.943,33.943,0,0,1-12.677,2.654C33.112,126.3,32.912,126.3,32.707,126.3Zm.045-41.876-.191,0a11.1,11.1,0,0,0-4.207.9,10.884,10.884,0,0,0-3.415,2.3,10.433,10.433,0,0,0-2.272,3.365,10,10,0,0,0-.783,4.078,10.214,10.214,0,0,0,3.26,7.277,11.023,11.023,0,0,0,7.606,3h.193a11.114,11.114,0,0,0,4.208-.9,10.868,10.868,0,0,0,3.414-2.3,10.416,10.416,0,0,0,2.272-3.365A10,10,0,0,0,43.62,94.7a10.206,10.206,0,0,0-3.26-7.277A11.021,11.021,0,0,0,32.753,84.422Z",
    transform: "matrix(1, 0.017, -0.017, 1, -9.282, 48.439)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 4.712,
    cy: 4.712,
    rx: 4.712,
    ry: 4.712,
    transform: "translate(218.015 16.683)",
    fill: "#b5d590",
    opacity: 0.995
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 4.712,
    cy: 4.712,
    rx: 4.712,
    ry: 4.712,
    transform: "translate(234.036 16.683)",
    fill: "#b5d590",
    opacity: 0.995
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 4.712,
    cy: 4.712,
    rx: 4.712,
    ry: 4.712,
    transform: "translate(250.056 16.683)",
    fill: "#b5d590",
    opacity: 0.995
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765",
    transform: "translate(111.917 67.861)",
    opacity: 0.498
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2961",
    "data-name": "Rectangle 2961",
    width: 64.098,
    height: 5.935,
    rx: 2.968,
    fill: "#b5d590"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2962",
    "data-name": "Rectangle 2962",
    width: 16.618,
    height: 5.935,
    rx: 2.968,
    transform: "translate(68.846)",
    fill: "#b5d590"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2963",
    "data-name": "Rectangle 2963",
    width: 29.675,
    height: 5.935,
    rx: 2.968,
    transform: "translate(0 18.992)",
    fill: "#b5d590"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2964",
    "data-name": "Rectangle 2964",
    width: 52.228,
    height: 5.935,
    rx: 2.968,
    transform: "translate(33.236 18.992)",
    fill: "#b5d590"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2965",
    "data-name": "Rectangle 2965",
    width: 75.968,
    height: 5.935,
    rx: 2.968,
    transform: "translate(0 37.984)",
    fill: "#b5d590"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2966",
    "data-name": "Rectangle 2966",
    width: 5.935,
    height: 5.935,
    rx: 2.968,
    transform: "translate(79.529 37.984)",
    fill: "#b5d590"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2967",
    "data-name": "Rectangle 2967",
    width: 40.358,
    height: 5.935,
    rx: 2.968,
    transform: "translate(0 56.976)",
    fill: "#b5d590"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2968",
    "data-name": "Rectangle 2968",
    width: 41.545,
    height: 5.935,
    rx: 2.968,
    transform: "translate(43.919 56.976)",
    fill: "#b5d590"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8373",
    "data-name": "Path 8373",
    d: "M-4782.778,2630.552h253.188",
    transform: "translate(4806.248 -2593.1)",
    fill: "none",
    stroke: "#f7f7f7",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4772",
    "data-name": "Group 4772",
    transform: "translate(505.985 240.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4771",
    "data-name": "Group 4771",
    transform: "translate(14.859 21.925)",
    opacity: 0.255
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8376",
    "data-name": "Path 8376",
    d: "M0,0V11.688",
    transform: "matrix(0.545, -0.839, 0.839, 0.545, 0, 0)",
    fill: "none",
    stroke: "#3787c9",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.764
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8377",
    "data-name": "Path 8377",
    d: "M0,14.046V0",
    transform: "matrix(0.695, 0.719, -0.719, 0.695, 14.855, 74.103)",
    fill: "none",
    stroke: "#3787c9",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.764
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8380",
    "data-name": "Path 8380",
    d: "M0,11.563V0",
    transform: "translate(86.083 2.278) rotate(45)",
    fill: "none",
    stroke: "#3787c9",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.764
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8381",
    "data-name": "Path 8381",
    d: "M0,0V21.012",
    transform: "translate(0 64.766) rotate(-90)",
    fill: "none",
    stroke: "#3787c9",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.549
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8382",
    "data-name": "Path 8382",
    d: "M-4761.443,2570.586v19.587",
    transform: "translate(4819.969 -2570.586)",
    fill: "none",
    stroke: "#3787c9",
    strokeLinecap: "round",
    strokeWidth: 2,
    opacity: 0.764
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationLock);
export default __webpack_public_path__ + "static/media/integrationLock.59ec908570d4c0c344e3401ea4bf3a07.svg";
export { ForwardRef as ReactComponent };